import { ComponentProps } from "react";
// eslint-disable-next-line drops/no-direct-spor-import
import { Checkbox } from "@vygruppen/spor-react";
import { FCWC } from "shared/utils/FCWC";
import styled, { DefaultTheme } from "styled-components";

type CheckboxProps = ComponentProps<typeof Checkbox>;

type DropsCheckboxProps = Omit<CheckboxProps, "title"> & {
  checked: boolean;
  disabled?: boolean;
};

const getBackgroundColor = ({
  theme,
  disabled,
  checked,
}: {
  theme: DefaultTheme;
  disabled?: boolean;
  checked?: boolean | "indeterminate";
}) => {
  if (disabled) return theme.surfaceHover;
  if (checked === true) return theme.colorSuccessTextSecondary;
  return theme.colorBackgroundMain;
};

const getBorderColor = ({
  theme,
  disabled,
  checked,
}: {
  theme: DefaultTheme;
  disabled?: boolean;
  checked?: boolean | "indeterminate";
}) => {
  if (disabled) return theme.colorOutlineSecondary;
  if (checked === true) return theme.colorSuccessTextSecondary;
  return theme.colorOutlineMain;
};

const StyledCheckbox = styled(Checkbox)`
  .css-p6k2rl {
    background-color: ${getBackgroundColor};
    border-color: ${getBorderColor};
  }

  .span {
    color: ${({ theme, disabled }) =>
      disabled ? theme.colorTextDisabled : theme.colorTextMain};
  }
`;

export const InternalDropsCheckbox: FCWC<DropsCheckboxProps> = ({
  checked,
  children,
  disabled,
  ...props
}) => (
  <StyledCheckbox {...props} disabled={disabled} checked={checked}>
    {children}
  </StyledCheckbox>
);
